<div class="DocContainer ">
  <div class="LeftFacet">
    <app-facet-navigation></app-facet-navigation>
  </div>
  <div class="rightSectionDoc ">
    <div class="formSectionTop">
      <h1 class="myProfileTopHeader m-0">
        {{'common.text_software_download_header'|cxTranslate}}
      </h1>
      <div class="myProfileBody">

        <form [formGroup]="docSearchForm" (ngSubmit)="search(0,defaultPageSize,'')">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <label class="software-search-label"
              for="search">{{'common.search_meta_title'|cxTranslate}}</label>
              <div class="col-12 px-0 softInputSearch">
                <input #searchInput type="text" formControlName="searchKey"
                  (input)="onSearchInput($event)"
                  (keydown.enter)=" onSearchInput($event);onSearch($event);clearRecentSearch()"
                  (keyup)="onSearchInput($event)" (focus)="onSearchInput($event)"
                  (click)="onSearchInput($event)"
                  [placeholder]="'common.software_library_placeholder_text'|cxTranslate">
                  @if (recentSearches.length > 0) {
                    <ul class="RecentSearch RecentSearchSOFTPopUP">
                      <p class="RecentSearchText">{{'common.recent_search'|cxTranslate}}</p>
                      @for (search of recentSearches; track search) {
                        <p class="RecentSearch-item">
                          <a (click)="populateSearchInput(search.value)"
                          class="RecentSearch-anchor">{{search.value}}</a>
                        </p>
                      }
                    </ul>
                  }
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                <label class="software-search-label"
                for="select">{{'common.text_software_group_download_heading'|cxTranslate}}</label>
                <div class="selectBox"><select formControlName="softwareGroup">
                  <option value="null" [selected]="form.softwareGroup.value==null">
                  {{'common.form_select_empty'|cxTranslate}}</option>
                  @for (item of ApiDataSearch?.softwareGroupList; track item) {
                    <option [value]="item?.name">
                    {{item?.name}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <label class="software-search-label"
              for="select">{{'common.text_software_download_heading'|cxTranslate}}</label>
              <div class="selectBox"><select formControlName="softwareType">
                <option value="null" [selected]="form.softwareType.value==null">
                {{'common.form_select_empty'|cxTranslate}}</option>
                @for (item of ApiDataSearch?.softwareTypeList ; track item) {
                  <option [value]="item?.name">
                  {{item?.name}}</option>
                }
              </select></div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <label class="software-search-label" class="software-search-label"
              for="select">{{'common.text_software_download_heading2'|cxTranslate}}</label>
              <div class="selectBox"><select formControlName="packageType">
                <option value="null" [selected]="form.packageType.value==null">
                {{'common.form_select_empty'|cxTranslate}}</option>
                @for (item of ApiDataSearch?.softwarePackageTypeList ; track item) {
                  <option
                    [value]="item?.name">
                    {{item?.name}}
                  </option>
                }
              </select></div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <label class="software-search-label"
              for="select">{{'common.document_library_text_language'|cxTranslate}}</label>
              <div class="selectBox"><select formControlName="softLanguage">
                <option value="null" [selected]="form.softLanguage.value==null" disabled>
                {{'common.form_select_empty'|cxTranslate}}</option>
                @for (item of ApiDataSearch?.softwareLanguageList ; track item) {
                  <option
                    [value]="item?.name">
                    {{item?.name}}
                  </option>
                }
              </select></div>
            </div>
          </div>
          <div class="buttonsContainer mt-4">
            <div>
              <button (click)="reset()" type="button"
              class="btn btn-blue reset-btn">{{'common.text_account_reset'|cxTranslate}}</button>
            </div>
            <div class="">
              <button class="btn btn-primary search-btn fs-20"
                type="submit">{{'common.search_meta_title'|cxTranslate}}
                <img class="hover-img" src="/icons/link-grey.svg" width="20px"></button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="bottomSectionPDP">
        <section class="cx-page-section">
          @if (productListService.seperateSoftDetails$|async; as softModel) {
            <div class="container1">
              @if (softModel?.softwareCounts) {
                <div class="row1">
                  @if (viewMode$ | async; as viewMode) {
                    <div class="">
                      <div class="cx-sorting top">
                        <div class="action-row sorting-block">
                          <label
                            class="d-none d-md-none d-lg-block col-lg-3 total-records">{{softModel.pagination.totalResults}}
                          {{'common.search_page_totalResults'|cxTranslate}}</label>
                          @if (softModel.pagination.totalResults >90 || softModel.pagination.totalResults >30) {
                            <label class="col-lg-3 pagination"
                              >{{'common.pagination_view'
                              | cxTranslate}}
                              @if (softModel.pagination.totalResults >30) {
                                <a class="page-size"
                                  [routerLink]="" (click)="changePageSize(30,softModel)"> &nbsp;30&nbsp;
                                </a>
                                } @if (softModel.pagination.totalResults >90) {
                                <span
                                  >{{'common.pagination_or'|cxTranslate}}
                                  <a class="page-size" [routerLink]="" (click)="changePageSize(90,softModel)">
                                    &nbsp;90&nbsp;
                                  </a></span>
                                }
                              {{'common.pagination_items' | cxTranslate}}</label>
                            }
                            @if (!isMobile) {
                              <div class="sort-select">
                                <label class="sort-by">
                                  <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                                </label>
                                <div class="col-lg-4 sorting">
                                  <cx-sorting [sortOptions]="softModel.sorts"
                                    (sortListEvent)="sortList($event, softModel)"
                                    [selectedOption]="softModel.pagination?.sort"
                                    [ariaLabel]="'productList.sortResults' | cxTranslate"
                                    ariaControls="product-results-list"
                                    placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                                  </cx-sorting>
                                </div>
                              </div>
                            }
                            @if (isMobile) {
                              <div class="d-flex col-12 doc-search-filter">
                                <div class="col-4 doc-left-search-filter">
                                  <app-facet-navigation></app-facet-navigation>
                                </div>
                                <div class="col-8 sort-select">
                                  <label class="sort-by">
                                    <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                                  </label>
                                  <div class=" sorting">
                                    <cx-sorting [sortOptions]="softModel.sorts"
                                      (sortListEvent)="sortList($event, softModel)"
                                      [selectedOption]="softModel.pagination?.sort"
                                      [ariaLabel]="'productList.sortResults' | cxTranslate"
                                      ariaControls="product-results-list"
                                      placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                                    </cx-sorting>
                                  </div>
                                </div>
                              </div>
                            }
                            <div class="col-lg-1 no-padding d-flex justify-content-end switch-btn">
                              <cx-product-view (modeChange)="setViewMode($event)"
                              [mode]="viewMode"></cx-product-view>
                            </div>
                          </div>
                        </div>
                        <div id="product-results-list" class="cx-product-container">
                          <!-- Product list when using pagination -->
                          @if (!isInfiniteScroll) {
                            @if (viewMode === ViewModes.Grid) {
                              <div class="row">
                                @for (product of softModel?.softwares; track product) {
                                  <app-kb-software-grid-item
                                    [product]="product" [searchQuery]="SearchQuery"
                                  class="col-12 col-sm-12 col-md-12 col-lg-3"></app-kb-software-grid-item>
                                }
                              </div>
                            }
                            @if (viewMode === ViewModes.List) {
                              @for (product of softModel?.softwares; track product) {
                                <app-kb-software-list-item
                                  [product]="product" [searchQuery]="SearchQuery"
                                  class="cx-product-search-list">
                                </app-kb-software-list-item>
                              }
                            }
                          } @else {
                            <cx-product-scroll [scrollConfig]="scrollConfig" [model]="softModel"
                            [inputViewMode]="viewMode"></cx-product-scroll>
                          }
                          <!-- Product list when using infinite scroll -->
                        </div>
                        <div class="cx-sorting bottom">
                          <div class="row col-md-12">
                            <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                              {{(softModel.pagination.pageSize *
                              softModel.pagination.currentPage)+1 }}-
                              @if (softModel.pagination.pageSize *(softModel.pagination.currentPage+1) < softModel.pagination.totalResults) {
                                <span
                                  >{{softModel.pagination.pageSize
                                *(softModel.pagination.currentPage+1)}}</span>
                              }
                              @if (softModel.pagination.pageSize *(softModel.pagination.currentPage+1) > softModel.pagination.totalResults) {
                                <span
                                >{{softModel.pagination.totalResults}}</span>
                              }
                              {{'common.search_page_of_text'|cxTranslate}}
                              {{softModel.pagination.totalResults}}
                            {{'common.search_page_result_text'|cxTranslate}}</label>
                            @if (!isInfiniteScroll) {
                              <div
                                class="col-auto col-md-7 d-flex justify-content-end align-items-center pr"
                                [attr.aria-label]="'productList.productSearchPagination' | cxTranslate">
                                <div class="kb-pagination">
                                  <kb-pagination [pagination]="softModel.pagination" [defaultPage]="0"
                                  (viewPageEvent)="changePageCustom($event,softModel)"></kb-pagination>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                } @else {
                  <div class="document-not-found">{{'common.fselect_noResultFound'|cxTranslate}}
                  </div>
                }
              </div>
            }
          </section>
        </div>
      </div>
    </div>